export default __webpack_public_path__ + "static/media/avatar_166.74ddfd28.png";